(function () {
    'use strict';

    angular.module("imApp").factory("prodBeoMethodLangsService", ['$ihttp', function ($ihttp) {
        let service = {
            listLanguages: function (parms) {
                return $ihttp.post({
                    method: 3458,
                    parameters: parms || {}
                });
            },
            saveObj: function (list) {
                return $ihttp.post({
                    method: 3459,
                    parameters: list
                });
            }
        };

        return service;
    }]);
})();
